import React from 'react'
import { Box } from '@chakra-ui/react'
import { LinearLoader } from '@zumma/ui'

export const RouteLoading: React.FC = () => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      minH='100vh'
      w='100%'
    >
      <LinearLoader />
    </Box>
  )
}
